import React, { lazy, Suspense } from 'react'

// Only import devtools in development — Vite tree-shakes this entire branch in production
const DevTools = import.meta.env.DEV
  ? lazy(() =>
      import('@tanstack/react-query-devtools').then((m) => ({
        default: m.ReactQueryDevtools,
      }))
    )
  : () => null;
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { Toaster } from 'sonner'
import App from './App'
import { ErrorDialogProvider } from './components/providers/ErrorDialogProvider'
import { TenantProvider } from './config/TenantProvider'
import { initializeCapacitor } from './utils/capacitor'
import { initSentry } from './utils/sentry'
import { initMixpanel } from './utils/mixpanel'
import './i18n'
import './index.css'

// Initialize Sentry and Mixpanel before React rendering
initSentry()
initMixpanel()

// Initialize Capacitor for mobile platforms
initializeCapacitor()

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      gcTime: 1000 * 60 * 5, // 5 minutes (same as staleTime)
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
})

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <TenantProvider>
          <ErrorDialogProvider>
            <App />
            <Toaster position="top-right" richColors closeButton />
          </ErrorDialogProvider>
        </TenantProvider>
      </BrowserRouter>
      {import.meta.env.DEV && <Suspense><DevTools initialIsOpen={false} /></Suspense>}
    </QueryClientProvider>
  </React.StrictMode>,
)
